export default __webpack_public_path__ + "static/media/yvote.6e0dc6c6.jpg";